<div class="container">
  <svg width="125" height="125" viewBox="0 0 110 110">
    <circle class="segment" *ngFor="let item of getDistribution(); index as i"
            [style.--width]="item.amount * 100+'px'"
            [style.--offset]="calcOffset(i)+'px'"
            [ngClass]="setClass(item.type)"
            pathLength="100"/>
  </svg>
  <div class="legend">
    <p class="item" *ngFor="let item of getDistribution()" [ngClass]="setClass(item.type)">
      {{setDisplayName(item.type) | transloco}}<span>{{item.amount*100 | number: '1.1-1'}}%
    </span></p>
  </div>
</div>
